// Import services from entity files
import * as schoolServices from "./schoolService";
import * as principalServices from "./principalService";
import * as placementQuestionServices from "./placementQuestionService";
import * as placementTestServices from "./placementTestService";

import * as studentServices from "./studentService";
import * as teacherServices from "./teacherService";
import * as teamMemberServices from "./teamMemberService";
import * as moduleQuestionServices from "./programService";
import * as classroomServices from "./classroomService";

// Export all services
export default {
  ...schoolServices,
  ...principalServices,
  ...placementQuestionServices,
  ...placementTestServices,
  ...studentServices,
  ...teacherServices,
  ...teamMemberServices,
  ...moduleQuestionServices,
  ...classroomServices,
};
